export default (state = { activeRegion: '', regionError: false }, action) => {
  switch (action.type) {
    case 'SET_REGION':
      return {
        ...state,
        ...{ activeRegion: action.payload },
      };
    default:
      return state;
  }
};
